import { Chip, Stack, Typography } from "@mui/material";
import { autoFormatCamelCase } from "@entrilia/shared/utilities/stringHelper";
import type { FieldAttribute } from "../../../../../api/types/objectTypes";

interface Props {
  fieldAttributes: FieldAttribute[];
}

const FieldAttributesSection = ({ fieldAttributes }: Props) => {
  if (fieldAttributes.length === 0) {
    return null;
  }

  return (
    <Stack spacing={1} sx={{ pt: 2 }}>
      <Typography variant="subtitle2">Attributes</Typography>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center", flexWrap: "wrap" }}>
        {[...fieldAttributes]
          .sort((a, b) => a.localeCompare(b))
          .map((attribute) => (
            <Chip key={attribute} label={autoFormatCamelCase(attribute)} />
          ))}
      </Stack>
    </Stack>
  );
};

export default FieldAttributesSection;
